import { Button } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Placeholder } from '@delmonicos/shared-design-system-react/src/components/placeholder/placeholder';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';

import * as css from '../charge-point-details/charge-point-details.module.scss';

export const ChargePointChannelDetailsPlaceholder = (): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <Stack
      alignItems="center"
      className={css.placeholderStack}
      direction="column"
      gap={GapEnum.XL}
      justifyContent="center">
      <Stack alignItems="center" direction="column" gap={GapEnum.M}>
        <Placeholder icon="electric-terminal" />
        <Text>{t('$.charge-point-details.channel-list.empty')}</Text>
      </Stack>
      <Button onClick={() => Logger.info('add channel')}>
        <Stack alignItems="center" gap={GapEnum.XS} justifyContent="center">
          <Icon name="plus" />
          {t('$.charge-point-details.channel-list.add-channel')}
        </Stack>
      </Button>
    </Stack>
  );
};
